module.exports = __webpack_public_path__ + "img/video-pic2.ffef3b0a.jpg";